import styled from 'styled-components'

import { Title as TitleUI } from '../styles'

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
  position: relative;
  ${({ theme }) => theme.below.laptop`
    margin-bottom: 400px;
    justify-content: center;
    padding: 0 ${theme.spaces[3]}px;
  `}
`

export const Title = styled(TitleUI)`
  margin-bottom: 30px;
`

export const TextList = styled.ol`
  margin-bottom: 30px;
  margin-left: 20px;
`

export const TextListNum = styled.li`
  counter-increment: my-counter;
  margin-bottom: 10px;
  padding-left: 100px;
  padding-top: 20px;
  position: relative;
  text-transform: uppercase;

  ::marker {
    content: counter(my-counter) '.';
    margin-right: 10px;
  }
`

export const Container = styled.div`
  position: relative;
  ${({ theme }) => theme.below.laptop`
    display: flex;
    justify-content: space-between;
    flex: 1;
    flex-wrap: wrap;
  `}
`

export const ContainerItem = styled.div`
  margin-right: 40px;
`

export const ImageDesktopWrapper = styled.div`
  height: 640px;
  object-fit: cover;
  position: absolute;
  right: 0;
  top: 80px;
  width: 700px;

  ${({ theme }) => theme.below.laptop`
    display: none;
  `}
`

export const ImageMobileWrapper = styled.div`
  align-self: center;
  bottom: -370px;
  height: 647px;
  left: 0;
  margin: 0 auto;
  object-fit: cover;
  position: absolute;
  right: 0;
  width: 300px;

  ${({ theme }) => theme.above.laptop`
    display: none;
  `}
`
